var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.valid)?_c('v-btn',{attrs:{"color":"primary","text":"","small":"","loading":_vm.loading},on:{"click":_vm.handleEdit}},[_vm._v("Review")]):_vm._e(),_c('ReviewForm',{ref:"reviewForm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }